/**
 * BlockedOverlay - Full screen block for subscription-gated content
 *
 * Shows when user tries to access content that requires a subscription.
 * Displays a lock icon, message, and CTA button to get subscription.
 */

import { useNavigate } from 'react-router-dom'

interface BlockedOverlayProps {
  message?: string
  buttonText?: string
  buttonHref?: string
}

export function BlockedOverlay({
  message = 'Subscription required to access',
  buttonText = 'Get Subscription',
  buttonHref = '/subscription'
}: BlockedOverlayProps) {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <div className="text-center max-w-md">
        {/* Lock icon */}
        <div className="w-20 h-20 bg-[#ece6dd] rounded-full flex items-center justify-center mx-auto mb-6">
          <svg
            className="w-10 h-10 text-[#5c5b44]"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
            />
          </svg>
        </div>

        {/* Message */}
        <h2 className="text-xl font-bold text-gray-900 mb-2">
          {message}
        </h2>
        <p className="text-gray-600 mb-6">
          Subscribe to unlock this feature and get access to exclusive content.
        </p>

        {/* CTA Button */}
        <button
          onClick={() => navigate(buttonHref)}
          className="px-8 py-3 bg-[#5c5b44] text-white rounded-lg font-medium hover:bg-[#5c5b44] transition-colors shadow-md"
        >
          {buttonText}
        </button>

        {/* Back link */}
        <button
          onClick={() => navigate(-1)}
          className="block w-full mt-4 text-sm text-gray-500 hover:text-gray-700"
        >
          Go back
        </button>
      </div>
    </div>
  )
}
